/**
 * Form state for the admin Contract card. Framework-free so it tests without firebase.
 */

import type { WorkspaceContract, WorkspaceContractUpdate } from "../services/naraDoor";

export interface ContractForm {
  billingHidden: boolean;
  topUpEnabled: boolean;
  /** Raw input text; converted on save. */
  topUpAmount: string;
  startDate: string;
  expireRemaining: boolean;
}

export function formFromContract(c: WorkspaceContract): ContractForm {
  return {
    billingHidden: c.billingHidden,
    topUpEnabled: c.topUpEnabled,
    topUpAmount: c.topUpAmount === null ? "" : String(c.topUpAmount),
    startDate: c.startDate ?? "",
    expireRemaining: c.expireRemaining,
  };
}

// Expiring a visible balance would remove Boosts a member paid for, so it needs Hide Billing.
export function withBillingHidden(form: ContractForm, billingHidden: boolean): ContractForm {
  return { ...form, billingHidden, expireRemaining: billingHidden && form.expireRemaining };
}

// Full replace: every field is sent, null when unused. The server validates the rest.
export function toContractUpdate(form: ContractForm): WorkspaceContractUpdate {
  const on = form.topUpEnabled;
  return {
    billingHidden: form.billingHidden,
    topUpEnabled: on,
    topUpAmount: on && form.topUpAmount !== "" ? Number(form.topUpAmount) : null,
    startDate: on && form.startDate ? form.startDate : null,
    expireRemaining: form.expireRemaining,
  };
}
